import React from "react";
import { ReactComponent as Check } from "../../../assets/check.svg";
import { ReactComponent as UnCheck } from "../../../assets/uncheck.svg";

const ValidationCheckBox = ({ passed, message }) => {
  return (
    <>
      {passed ? (
        <div className="flex items-center mb-1">
          <Check />
          <label
            for="disabled-checked-checkbox"
            className="ml-2 text-sm font-normal text-offBlack text-f12 md:text-f16"
          >
            {message}
          </label>
        </div>
      ) : (
        <div className="flex items-center mb-1">
          <UnCheck />
          <label
            for="disabled-checkbox"
            className="ml-2 text-sm font-normal text-offBlack text-f12 md:text-f16 "
          >
            {message}
          </label>
        </div>
      )}
    </>
  );
};

export default ValidationCheckBox;
